import script from "./BookingsSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingsSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./BookingsSidebarDetails.vue?vue&type=style&index=0&id=5d8b8460&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8b8460"]])

export default __exports__